import React, { useState } from 'react';

const FooterUI = () => {
  const [showEndCard, setShowEndCard] = useState(false);
  return (
    <>
    <div 
      onClick={() => setShowEndCard(true)}
      style={{
        cursor: 'pointer',
      position: 'absolute',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      textAlign: 'center',
      color: '#FF732C',
      fontSize: 28,
      fontWeight: 700,
      letterSpacing: 2,
      lineHeight: 1.4,
      padding: '12px 24px',
      maxWidth: 600,
      whiteSpace: 'pre-line',
      backgroundColor: 'rgba(0,0,0,0.7)',
      borderRadius: '8px',
      border: '1px solid #FF732C',
      boxShadow: '0 0 20px rgba(255, 115, 44, 0.3)',
      fontFamily: 'monospace',
      zIndex: 10,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '5px'
    }}>
      <img 
        src="/MartoverTotalLogo.svg" 
        alt="MARTOVER" 
        style={{
          height: '40px',
          width: 'auto'
        }}
      />
      <div style={{
        fontSize: '16px',
        opacity: 0.8
      }}>在火星土壤播种明日盛宴</div>
      <div style={{
        width: '80%',
        height: '2px',
        background: 'rgba(255, 115, 44, 0.5)',
        margin: '8px 0',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: '0',
          left: '0',
          width: '30%',
          height: '100%',
          background: '#fff',
          animation: 'moveLight 2s infinite linear'
        }}></div>
      </div>
    </div>
    
    {/* END卡片 */}
    {showEndCard && (
      <div 
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}
        onClick={() => setShowEndCard(false)}
      >
        <div style={{
          backgroundColor: 'rgba(0,0,0,0.9)',
          border: '1px solid #FF732C',
          borderRadius: '8px',
          padding: '40px 60px',
          textAlign: 'center',
          color: '#FF732C',
          fontFamily: 'monospace'
        }}>
          <div style={{
            fontSize: '48px',
            fontWeight: 'bold',
            marginBottom: '20px'
          }}>END</div>
          <div style={{
            fontSize: '14px',
            opacity: 0.8,
            marginBottom: '20px'
          }}>开发中，敬请期待<br/>可查看文档详情</div>
          <img 
            src="/imgs/feishu_link.svg" 
            alt="二维码" 
            style={{
              width: '120px',
              height: '120px'
            }}
          />
        </div>
      </div>
    )}
    </>
  );
};

export default FooterUI;